import { checkNull, isObjectNull } from "utils/utils";

const conferenceServiceName = "/Conference";

export function conferenceService(http) {
    return {        
        getConferenceAsync: (userId, conferenceDate, hallId) => {
            var parameterContainer = {
                creatorUserId: userId,
                StartDate: conferenceDate,
                HallId: hallId
            }
            return http.post(conferenceServiceName + "/GetAppointmentsAsync", parameterContainer)
        },
        getFloors: (isAdmin = false) => {
            let params = {
                isAdmin
            };

            return http.post(conferenceServiceName + "/GetFloors", params);
        }, 
        getMinimumAppointmentTimeEver: () => {
            return http.get(conferenceServiceName + "/getMinimumAppointmentTimeEver");
        },
        getAppointmentReportDataAsync: (parametersObject) => {
            return http.post(conferenceServiceName + "/GetAppointmentReportDataAsync", parametersObject);
        },
        getMaximumAppointmentTimeEver: () => {
            return http.get(conferenceServiceName + "/GetMaximumAppointmentTimeEver");
        },
        getFloorHalls: (floor, isAdmin = false) => {
            var parameter = {
                Floor: floor,
                isAdmin
            };
            return http.post(conferenceServiceName + "/GetFloorHalls", parameter);
        },
        getMaximumAvailableDayRule: _ =>{
            return http.get(conferenceServiceName + "/GetMaximumAvailableDayRule");
        },
        getMaximumAppointmentReservableInDaysRule: _ => {
            return http.get(conferenceServiceName + "/getMaximumAppointmentReservableInDaysRule");
        },
        getConferenceTypes: () => {
            return http.post(conferenceServiceName + "/GetConferenceTypes");
        },
        getLaunchTypes: () => {
            return http.post(conferenceServiceName + "/GetLaunchTypes");
        },
        getRules: () => {
            return http.post(conferenceServiceName + "/GetRuls");
        },
        getHalls: () => {
            return http.post(conferenceServiceName + "/GetHalls");
        },    
        getHall: (hallId) => {

            return http.get(`${conferenceServiceName}/GetHall?hallId=${hallId}`);
        },    
        isUserAdministratorAsync: (userId) => {    
            let param = {
                UserId: userId
            }        
            return http.post(conferenceServiceName + "/IsUserAdministratorAsync", param);
        },
        updateSetting: (ruleList) => {
            return http.post(conferenceServiceName + "/UpdateSettingAsync", ruleList);
        },
        updateHallsAvailability: (hallActivationList) => {
            return http.post(conferenceServiceName + "/UpdateHallsAvailability", hallActivationList);
        },
        updateHallsChairs: (id, chairs, extraChairs) => {
            let param = {
                id,
                chairs,
                extraChairs
            } 
            debugger;
            return http.post(conferenceServiceName + "/UpdateHallChairsAsync", param);
        },        
        // isSystemPermittedUser: (userTypeId, userProfileId, isPowerUser) => {
        //     let param = {
        //         Id: userTypeId,
        //         UserProfileId: userProfileId,
        //         isPowerUser: isPowerUser
        //     }  
        //     return http.post(conferenceServiceName + "/IsSystemPermittedUser", param);
        // },
        saveAppointmentAsync: async (userId, title, description, startDate, endDate, typeId, hallId, guestNumber = null,guestCompany = null,
            guestIdentification = null, allDay, hasComputer = false, hasVideoConference = false, hasPointer = false, hasSpecialEntertaining = false,
            hasInternet = false, hasWifi = false, hasFruite = false, hasParking = false, hasWelcome = false, LauchType = false, 
            welcomingStaff = false, otherRequests) => {
            var appointmentContainer = {
                creatorUserId: userId,
                title: title,
                description: description,
                stringStartDate: startDate,
                stringEndDate: endDate,
                typeId: typeId,
                hallId: hallId,
                guestNumber: guestNumber,
                guestCompany: guestCompany,
                guestIdentification: guestIdentification,
                allDay: allDay,
                requirement:{
                    hasComputer: hasComputer,
                    hasVideoConference: hasVideoConference,
                    hasPointer: hasPointer,
                    hasSpecialEntertaining: hasSpecialEntertaining,
                    hasInternet: hasInternet,
                    hasWifi: hasWifi,
                    hasFruite: hasFruite,
                    hasParking: hasParking,
                    hasWelcome: hasWelcome,
                    LauchTypeId: LauchType.value,
                    welcomingStaff: welcomingStaff,
                    otherRequest: otherRequests
                }
            };

            return await http.post(conferenceServiceName + "/AddNewAppointmentAsync", appointmentContainer);                
        },
        confirmAppointmentAsync: async (id, userId, confirmationTime) => {
            var parameter = {
                Id: id,
                creatorUserId: userId,
                ConfirmationTime: confirmationTime
            };
            return http.post(conferenceServiceName + "/ConfirmAppointmentAsync",parameter);
        },
        removeAppointment: async (id, userId) => {
            var parameter = {
                Id: id,
                omitterUserId: userId
            };
            return http.post(conferenceServiceName + "/RemoveAppointment",parameter);
        },
        modifyAppointment: async (id, requirementId, userId, title, description, startDate, endDate, typeId, hallId, guestNumber,guestCompany,
            guestIdentification, allDay, hasComputer, hasVideoConference, hasPointer, hasSpecialEntertaining,
            hasInternet, hasWifi, hasFruite, hasParking, hasWelcome, LauchType, welcomingStaff, otherRequests) => {
                var appointmentContainer = {
                    Id: id,
                    creatorUserId: userId,
                    title: title,
                    description: description,
                    startDate: startDate,
                    endDate: endDate,
                    typeId: typeId,
                    hallId: hallId,
                    guestNumber: guestNumber,
                    guestCompany: guestCompany,
                    guestIdentification: guestIdentification,
                    allDay: allDay,
                    requirement:{
                        id:requirementId,
                        hasComputer: hasComputer,
                        hasVideoConference: hasVideoConference,
                        hasPointer: hasPointer,
                        hasSpecialEntertaining: hasSpecialEntertaining,
                        hasInternet: hasInternet,
                        hasWifi: hasWifi,
                        hasFruit: hasFruite,
                        hasParking: hasParking,
                        hasWelcome: hasWelcome,
                        LauchTypeId: checkNull(LauchType) ? null : LauchType.value,
                        welcomingStaff: welcomingStaff,
                        otherRequest: otherRequests
                    }
                };
            return await http.post(conferenceServiceName + "/UpdateExistingAppointmentAsync",appointmentContainer);
        }          
    }
}
